// ═══════════════════════════════════════════════
//   FILES + SHOP — inventory tabs + shop items
// ═══════════════════════════════════════════════

const {S, BG_IMGS, BG_NAMES, ALIENS, GACHA_POOL, ALL_NICKS, SFX, addPts, toast, scheduleSave} = window;

// ══════════════════════════════════════════
// INVENTORY
// ══════════════════════════════════════════

// Public entry: renders every section + counter. Kept as `renderInvBgs`
// to preserve the single global hook called from auth.js / shop / etc.
function renderInvBgs() {
    _renderInvBackgrounds();
    if (window.renderInvIcons) window.renderInvIcons();
    _renderInvAliens();
    _renderInvToys();
    _renderInvNicks();
    _renderInvRewards();
    _renderInvCounter();
}

function _renderInvCounter() {
    const el = document.getElementById('inv-counter');
    if (!el) return;
    const totals = [
        S.unlockedBgs?.length || 0,
        S.myAliens?.length || 0,
        S.myToys?.length || 0,
        S.unlockedNicks?.length || 0,
        S.ownedIrl?.length || 0,
    ];
    const sum = totals.reduce((a, b) => a + b, 0);
    el.innerHTML = `<b>${sum}</b> ITEMS`;
}

function _renderInvBackgrounds() {
    const grid = document.getElementById('inv-bg-grid');
    if (!grid) return;
    grid.innerHTML = '';
    Object.keys(BG_IMGS).forEach(key => {
        const unlocked = S.unlockedBgs.includes(key);
        const d = document.createElement('div');
        d.className = 'inv-bg-item' + (S.activeBg === key ? ' active' : '') + (unlocked ? '' : ' inv-locked');
        d.innerHTML = `<img src="${BG_IMGS[key]}" alt="${BG_NAMES[key]}"><div class="inv-bg-label">${BG_NAMES[key]}</div>${unlocked ? '' : `<div class="inv-lock-icon">🔒</div>`}`;
        if (unlocked) d.addEventListener('click', () => setDesktopBg(key));
        grid.appendChild(d);
    });
}

function _renderInvAliens() {
    const grid = document.getElementById('inv-alien-grid');
    if (!grid) return;
    const alienPool = (GACHA_POOL || []).filter(e => e.type === 'alien');
    if (!alienPool.length) {
        grid.innerHTML = '<div class="inv-empty">No aliens to discover yet ✦</div>';
        return;
    }
    const owned = new Set((S.myAliens || []).map(a => a.alienId));
    const counts = {};
    (S.myAliens || []).forEach(a => { counts[a.alienId] = (counts[a.alienId] || 0) + 1; });

    grid.innerHTML = alienPool.map(e => {
        const a = ALIENS[e.id]; if (!a) return '';
        const has = owned.has(a.id);
        const count = counts[a.id] || 0;
        const rare = a.rarity === 'rare';
        return `
            <div class="inv-tile${has ? '' : ' locked'}">
                ${has && count > 1 ? `<span class="inv-tile-count">×${count}</span>` : ''}
                ${has && rare ? '<span class="inv-tile-rare">✦</span>' : ''}
                ${!has ? '<span class="inv-tile-locktag">🔒</span>' : ''}
                <div class="inv-tile-thumb"><img src="${a.img}" alt="${a.name}"></div>
                <div class="inv-tile-name">${has ? a.name : '???'}</div>
            </div>`;
    }).join('');
}

function _renderInvToys() {
    const grid = document.getElementById('inv-toy-grid');
    if (!grid) return;
    const toyPool = (GACHA_POOL || []).filter(e => e.type === 'toy');
    if (!toyPool.length) {
        grid.innerHTML = '<div class="inv-empty">No toys yet — try the gacha ✦</div>';
        return;
    }
    const ownedMap = {};
    (S.myToys || []).forEach(t => { ownedMap[t.id] = t; });

    grid.innerHTML = toyPool.map(t => {
        const has = !!ownedMap[t.id];
        const count = ownedMap[t.id]?.count || 0;
        return `
            <div class="inv-tile${has ? '' : ' locked'}">
                ${has && count > 1 ? `<span class="inv-tile-count">×${count}</span>` : ''}
                ${!has ? '<span class="inv-tile-locktag">🔒</span>' : ''}
                <div class="inv-tile-thumb"><img src="${t.img}" alt="${t.name}"></div>
                <div class="inv-tile-name">${has ? t.name : '???'}</div>
            </div>`;
    }).join('');
}

function _renderInvNicks() {
    const list = document.getElementById('inv-nick-list');
    if (!list) return;
    if (!ALL_NICKS?.length) { list.innerHTML = '<div class="inv-empty">No titles yet ✦</div>'; return; }

    const owned = new Set(S.unlockedNicks || []);
    const equipped = (S.profileData && S.profileData.nick) || '';

    list.innerHTML = ALL_NICKS.map(n => {
        const has = owned.has(n.id);
        const isOn = has && equipped === n.id;
        const cls = ['inv-nick'];
        if (n.rarity) cls.push(n.rarity);
        if (!has) cls.push('locked');
        if (isOn) cls.push('equipped');
        const label = has ? n.label : '🔒 ' + (n.how || 'Locked');
        const tip = has ? (isOn ? 'Equipped — change in profile' : n.label) : (n.how || 'Locked');
        return `<span class="${cls.join(' ')}" title="${tip}">${label}</span>`;
    }).join('');
}

function _renderInvRewards() {
    const rew = document.getElementById('inv-rewards');
    if (!rew) return;
    if (!S.ownedIrl || S.ownedIrl.length === 0) {
        rew.innerHTML = '<div class="inv-empty">No rewards yet! Visit the shop ✦</div>';
        return;
    }
    rew.innerHTML = '';
    S.ownedIrl.forEach(item => {
        const d = document.createElement('div');
        d.className = 'inv-reward-item';
        d.innerHTML = `<div class="inv-reward-icon">${item.icon}</div><div><div class="inv-reward-name">${item.name}</div><div class="inv-reward-code">Code: ${item.code}</div></div>`;
        rew.appendChild(d);
    });
}

function setDesktopBg(key) {
    S.activeBg = key;
    document.getElementById('s-desktop').style.backgroundImage = `url(${BG_IMGS[key]})`;
    scheduleSave();
    renderInvBgs();
    toast(`Background changed! 🖼️`);
}

// ══════════════════════════════════════════
// SHOP
// ══════════════════════════════════════════
let shopFilter = 'all';

function setShopFilter(type) {
    shopFilter = type;
    document.querySelectorAll('.shop-filter').forEach(b => {
        b.classList.toggle('on', b.dataset.filter === type);
    });
    renderShop();
}

function _isOwned(item) {
    if (item.type === 'bg')        return S.unlockedBgs.includes(item.value);
    if (item.type === 'tama_slot') return S.maxTamaSlots >= item.value;
    return S.ownedIrl.some(r => r.id === item.id) || S.unlockedNicks.includes(item.value);
}

const SHOP_TYPE_META = {
    bg:        { label: 'WALLPAPERS', short: '🖼 WALL', cls: 't-bg',   hint: 'WEAR THEM ON YOUR DESKTOP' },
    nick:      { label: 'TITLES',     short: '♛ NICK',  cls: 't-nick', hint: 'SHOW OFF NEXT TO YOUR NAME' },
    tama_slot: { label: 'PET SLOTS',  short: '👾 SLOT', cls: 't-slot', hint: 'ROOM FOR ONE MORE FRIEND' },
    irl:       { label: 'IRL CODES',  short: '🎟 IRL',  cls: 't-irl',  hint: "WE'LL HAND YOU A REAL CODE → REDEEM AT OUR EVENTS" },
};
const SHOP_TYPE_ORDER = ['bg', 'nick', 'tama_slot', 'irl'];

function _shopThumbHTML(item) {
    if (item.type === 'bg') {
        const url = (window.BG_IMGS || {})[item.value];
        const bg = url ? `background-image:url(${url});` : 'background:linear-gradient(180deg,#ff4fa3,#ffe9c7);';
        return `<div class="shop-thumb shop-thumb-bg" style="${bg}"></div>`;
    }
    if (item.type === 'nick') {
        return `<div class="shop-thumb shop-thumb-nick"><div class="shop-thumb-nick-pill">♛ ${(item.name || '').toUpperCase()}</div></div>`;
    }
    if (item.type === 'tama_slot') {
        return `<div class="shop-thumb shop-thumb-slot"><span>👾</span><span>👾</span><span>👾</span><span>👾</span><span class="shop-slot-plus">+</span></div>`;
    }
    if (item.type === 'irl') {
        return `<div class="shop-thumb shop-thumb-irl"><div class="shop-thumb-irl-emoji">${item.icon || '🎟'}</div><div class="shop-thumb-irl-text"><div class="shop-thumb-irl-tag">IRL · KONBINI</div><div class="shop-thumb-irl-name">${item.name}</div></div></div>`;
    }
    return `<div class="shop-thumb" style="background:#fff;"><div style="font-size:32px;">${item.icon || '?'}</div></div>`;
}

function _shopCardHTML(item, opts = {}) {
    const meta  = SHOP_TYPE_META[item.type] || { short: '?', cls: '' };
    const owned = _isOwned(item);
    const can   = !owned && S.pts >= item.cost;
    const featBadge = opts.featuredBadge ? `<span class="shop-item-feat">★ NEW</span>` : '';
    const ownedStamp = owned ? `<span class="shop-owned-stamp">♥ OWNED</span>` : '';
    const lockedOverlay = (!owned && !can)
        ? `<div class="shop-locked-overlay"><span class="shop-locked-pill">🔒 KEEP PLAYING</span></div>`
        : '';
    let action;
    if (owned) {
        if (item.type === 'bg' && S.activeBg !== item.value) {
            action = `<button class="shop-equip" onclick="setDesktopBg('${item.value}')">EQUIP</button>`;
        } else {
            action = `<span class="shop-need" style="color:var(--lime);">✓ OWNED</span>`;
        }
    } else if (can) {
        const cls = item.type === 'irl' ? 'shop-buy irl' : 'shop-buy';
        const lbl = item.type === 'irl' ? '🎟 REDEEM' : '♥ BUY';
        action = `<button class="${cls}" onclick="buyItem('${item.id}')">${lbl}</button>`;
    } else {
        action = `<span class="shop-need">NEED +${(item.cost - S.pts).toLocaleString()}</span>`;
    }
    const priceCls = can || owned ? '' : ' cant';
    return `
        <div class="shop-item">
            ${featBadge}
            <span class="shop-item-typebadge ${meta.cls}">${meta.short}</span>
            <div class="shop-thumb-wrap">${_shopThumbHTML(item)}${lockedOverlay}${ownedStamp}</div>
            <div class="shop-item-name">${item.name}</div>
            <div class="shop-item-hint">${item.desc || ''}</div>
            <div class="shop-item-foot">
                <span class="shop-price${priceCls}">🪙 ${Number(item.cost).toLocaleString()}</span>
                ${action}
            </div>
        </div>`;
}

function _pickFeatured(items) {
    const wallpapers = items.filter(i => i.type === 'bg' && !_isOwned(i));
    if (wallpapers.length) return wallpapers.reduce((a, b) => (a.cost >= b.cost ? a : b));
    const buyables = items.filter(i => !_isOwned(i));
    if (buyables.length) return buyables.reduce((a, b) => (a.cost >= b.cost ? a : b));
    return items[0];
}

function _renderBakeryExchange() {
    const CFG = window.GAME_BAKERY;
    if (!CFG) return '';
    const coins = S.bakeryCoins || 0;
    const blocks = Math.floor(coins / CFG.exchangeMinCoins);
    const ptsAvail = blocks * (CFG.exchangeMinCoins / CFG.exchangeCoinsPerPt);
    const canExchange = blocks > 0;
    const coinsNeeded = CFG.exchangeMinCoins - (coins % CFG.exchangeMinCoins);
    const sideHtml = canExchange
        ? `<div class="shop-bkr-pts-avail">+${ptsAvail} pts</div>
           <button class="shop-bkr-btn" onclick="exchangeBakeryCoins();renderShop();">EXCHANGE ▶</button>`
        : `<div class="shop-bkr-pts-locked">${coins > 0 ? `${coinsNeeded.toLocaleString()} more` : 'Bake first!'}</div>
           <button class="shop-bkr-btn" disabled>EXCHANGE</button>`;
    const bodyLine = coins > 0
        ? `You have <strong>${coins.toLocaleString()}</strong> bakery coins`
        : 'Bake items in the bakery to earn coins here';
    return `<div class="shop-bkr-exchange${canExchange ? '' : ' locked'}">
        <div class="shop-bkr-icon">🥐</div>
        <div class="shop-bkr-body">
            <div class="shop-bkr-tag">BAKERY EXCHANGE</div>
            <div class="shop-bkr-line">${bodyLine}</div>
            <div class="shop-bkr-rate">Rate: ${CFG.exchangeMinCoins.toLocaleString()} coins → ${CFG.exchangeMinCoins / CFG.exchangeCoinsPerPt} pts</div>
        </div>
        <div class="shop-bkr-side">${sideHtml}</div>
    </div>`;
}

function renderShop() {
    const root = document.getElementById('shop-scroll');
    if (!root) return;

    const exchangeHtml = _renderBakeryExchange();
    const all = window.SHOP_ITEMS || [];
    if (!all.length) {
        root.innerHTML = exchangeHtml + '<div class="shop-empty">Nothing here yet!</div>';
        return;
    }

    const visible = shopFilter === 'all' ? all : all.filter(i => i.type === shopFilter);
    if (!visible.length) {
        root.innerHTML = exchangeHtml + '<div class="shop-empty">Nothing here yet!</div>';
        return;
    }

    let html = exchangeHtml;

    if (shopFilter === 'all') {
        const feat = _pickFeatured(all);
        if (feat) {
            const can = S.pts >= feat.cost && !_isOwned(feat);
            const owned = _isOwned(feat);
            const btn = owned
                ? (feat.type === 'bg' ? `<button class="shop-feat-buy" onclick="setDesktopBg('${feat.value}')">EQUIP</button>` : '')
                : `<button class="shop-feat-buy" ${can ? '' : 'disabled'} onclick="buyItem('${feat.id}')">♥ BUY</button>`;
            html += `
                <div class="shop-feat">
                    <span class="shop-feat-spark">✦</span>
                    <div class="shop-feat-thumb">${_shopThumbHTML(feat)}</div>
                    <div class="shop-feat-body">
                        <div class="shop-feat-tag">★ FEATURED THIS WEEK</div>
                        <div class="shop-feat-name">${feat.name}</div>
                        <p class="shop-feat-desc">${feat.desc || ''}</p>
                    </div>
                    <div class="shop-feat-side">
                        <span class="shop-price">🪙 ${Number(feat.cost).toLocaleString()}</span>
                        ${btn}
                    </div>
                </div>`;
        }
    }

    const types = shopFilter === 'all' ? SHOP_TYPE_ORDER : [shopFilter];
    types.forEach(type => {
        const list = visible.filter(i => i.type === type);
        if (!list.length) return;
        const meta = SHOP_TYPE_META[type] || { label: type.toUpperCase(), hint: '' };
        const head = type === 'irl'
            ? `<span class="shop-sec-tag-irl">🎟 IRL CODES · REAL WORLD</span><span class="shop-sec-hint">${meta.hint}</span>`
            : `<span class="shop-sec-title">${meta.short ? meta.short.split(' ')[0] : ''} ${meta.label}</span><span class="shop-sec-hint">${list.length} IN STOCK · ${meta.hint}</span>`;
        const cards = list.map(i => _shopCardHTML(i)).join('');
        html += `<div class="shop-section"><div class="shop-sec-head">${head}</div><div class="shop-grid">${cards}</div></div>`;
    });

    root.innerHTML = html;
}

function buyItem(id) {
    SFX.play('pts');
    const item = window.SHOP_ITEMS.find(i => i.id === id);
    if (!item || S.pts < item.cost) return;
    addPts(-item.cost, `shop:${item.id}`);
    if (item.type === 'bg') {
        window.unlockBg(item.value);
        setDesktopBg(item.value);
        renderInvBgs();
        toast(`${item.name} unlocked! Check Inventory 🖼️`);
    } else if (item.type === 'nick') {
        window.unlockNick(item.value);
        toast(`${item.name} unlocked! Check Profile ✦`);
    } else if (item.type === 'tama_slot') {
        S.maxTamaSlots = parseInt(item.value, 10);
        window.renderTamaSelect();
        toast(`Pet Slot ${item.value} unlocked! 🐾`);
    } else {
        S.ownedIrl.push({id: item.id, name: item.name, code: item.value, icon: item.icon});
        renderInvBgs();
        if (window.updateProfileDisplay) window.updateProfileDisplay();
        toast(`Redeemed! Show at booth: ${item.value} — see Inventory! 🎉`);
    }
    window.unlockNick('shopaholic');
    if (window.triggerMission) window.triggerMission('shop_buy');
    renderShop();
}

window.renderInvBgs = renderInvBgs;
window.setDesktopBg = setDesktopBg;
window.renderShop   = renderShop;
window.setShopFilter = setShopFilter;
window.buyItem      = buyItem;
